export const EXTEND_ELEMENT_TYPE_TRANSLATIONS: { [key: string]: string } = {
	randomMultipleChoice: "Fragen-Baustein",
};
